import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  IconButton,
  Grid,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import DrawerUI from "../../common/DrawerUI";
import AppbarUI from "../../common/AppbarUI";
import { Helmet } from "react-helmet";
import BodyWapperUI from "../../common/BodyWapperUI";
import { DatePicker } from "@mui/x-date-pickers";
import { appStatsAction } from "../../redux/toolkit/stats/appStats";
import { render } from "@testing-library/react";
import LabelText from "../../common/LabelText";
import { useTheme } from "@mui/material";

function AppStats() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [pagination, setPagination] = useState({ page: 0, limit: 25 });
  const [pageState, setPageState] = useState({ page: 1, pageSize: 25 });
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const appLists = useSelector((state) => state.appStats);
  const { status, data, loading: listLoading, total } = appLists;

  const dateWiseUser = () => {
    dispatch(
      appStatsAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
      })
    );
  };

  useEffect(() => {
    dispatch(
      appStatsAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        email: undefined,
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "appName",
      headerName: "App Name",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "totalClicks",
      headerName: "Clicks",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "convertedClicks",
      headerName: "Conversion Rate %",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const conversionRate =
          (params?.row?.completedSurveys / params?.row?.totalClicks) * 100;
        return <p>{Math.floor(conversionRate || 0)}</p>;
      },
    },
    {
      field: "completedSurveys",
      headerName: "Completes",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "screenoutSurveys",
      headerName: "Screen Outs",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "revenue",
      headerName: "Revenue USD",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <p>{params?.row?.revenue.toFixed(4)}</p>;
      },
    },
  ];

  const handlePageChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: params.page,
    }));
  };

  const handlePageSizeChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: 1,
      pageSize: params.pageSize,
    }));
  };

  return (
    <>
      <Helmet>
        <title> Real Opinion Publisher | Stats </title>
      </Helmet>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        <Typography variant="h6" fontWeight={600}>
          Apps Statistics
        </Typography>
        <Stack
          //   direction="row"
          //   style={{ display: "flex", justifyContent: "space-between" }}
          direction="row"
          sx={{
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          }}
        >
          <Stack
            sx={{ mt: 1 }}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          ></Stack>
          <Stack
            //   direction="row"
            //    spacing={2}
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems={{ xs: "stretch", sm: "center" }}
            width="100%"
          >
            <Grid
              //  xs={6}
              xs={12}
              sm={6}
            >
              <LabelText text="Start Date" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) => {
                    setDate({ ...date, startDate: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "Start Date", // force it inside inputProps
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid s={12} sm={6}>
              <LabelText text="End Date" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date?.endDate}
                  minDate={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) => {
                    setDate({ ...date, endDate: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "End Date", // force it inside inputProps
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid s={12} sm={6}>
              {date.startDate && date.endDate && (
                <Button
                  variant="contained"
                  sx={{
                    // backgroundColor: "#0C6A96",
                  // backgroundImage: "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                    backgroundColor: "#000",
                    '&:hover': {
                      backgroundColor: "#000",
                    },
                    mt: { xs: 2, sm: 5 },
                    width: { xs: "100%", sm: "auto" },
                  }}
                  onClick={dateWiseUser}
                >
                  find data
                </Button>
              )}
            </Grid>
          </Stack>
        </Stack>

        <Paper
          sx={{
            marginTop: 2,
            bgcolor: "#fff",
            "& .super-app-theme--header": {
              background: "rgba(254, 206, 113, 0.16)",
              color: "#000",
              borderBottom: " 1px solid #000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            },
          }}
          elevation={0}
        >
          <DataGrid
            sx={{
              border: " 1px solid #000",
              "& .MuiDataGrid-row:hover": {
                background: "rgba(254, 206, 113, 0.16)",
                cursor: "pointer",
              },
            }}
            // className={classes.root}
            getRowHeight={({ densityFactor }) => {
              return 70 * densityFactor;
            }}
            autoHeight
            rows={data}
            columns={AppColumns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            pagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            disableColumnSelector
            loading={listLoading ? <LoadingUI /> : false}
            onCellClick={(params) => {
              setPublisher_id(params?.row?._id);
            }}
            components={{
              NoRowsOverlay: () => <NoDataFound />,
            }}
            rowCount={total}
            paginationModel={setPageState}
            page={pageState.page}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
          />
        </Paper>
      </BodyWapperUI>
    </>
  );
}

export default AppStats;
